import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7876c13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "container-wide flex-shrink-1 flex-grow-1 d-flex flex-column p-0",
  style: {"min-height":"0"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "p-4" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "p-4" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "p-4" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "p-4" }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"overflow":"auto"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "p-4" }
const _hoisted_24 = { class: "p-4" }
const _hoisted_25 = { class: "p-4" }
const _hoisted_26 = { class: "p-4" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "p-4" }
const _hoisted_29 = { class: "p-4" }
const _hoisted_30 = { class: "p-4" }
const _hoisted_31 = { class: "p-4" }
const _hoisted_32 = { class: "card bg-white p-5 mb-4" }
const _hoisted_33 = { class: "card bg-white p-5" }
const _hoisted_34 = { class: "d-flex flex-row justify-content-between align-items-center mb-5" }
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "d-flex flex-wrap align-items-center px-3 py-2" }
const _hoisted_40 = { class: "d-flex flex-row flex-grow-1" }
const _hoisted_41 = { class: "flex-shrink-0" }
const _hoisted_42 = { class: "m-0 font-weight-bold" }
const _hoisted_43 = { class: "m-0 font-weight-bold" }
const _hoisted_44 = { class: "flex-grow-1 px-4" }
const _hoisted_45 = { class: "m-0" }
const _hoisted_46 = { class: "m-0" }
const _hoisted_47 = { class: "p-4" }
const _hoisted_48 = { class: "mb-0" }
const _hoisted_49 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_50 = {
  key: 6,
  class: "mt-3"
}
const _hoisted_51 = {
  key: "startApplicationPhaseWhenPublished",
  class: "mb-3"
}
const _hoisted_52 = {
  key: "skipApplicationPhase",
  class: "mb-3"
}
const _hoisted_53 = {
  key: "startOfferPhase",
  class: "mb-3"
}
const _hoisted_54 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = { class: "mb-2" }
const _hoisted_58 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_59 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_62 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_63 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_67 = { key: 2 }
const _hoisted_68 = { class: "mb-2" }
const _hoisted_69 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_70 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_73 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_76 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_77 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_78 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_81 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_82 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_83 = { class: "pb-4" }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = {
  key: 0,
  class: "my-2"
}
const _hoisted_86 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_87 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_88 = { class: "pb-4" }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  key: 0,
  class: "my-2"
}
const _hoisted_91 = { class: "px-4 pt-4 pb-1" }
const _hoisted_92 = { class: "text-primary m-0" }
const _hoisted_93 = { class: "mb-0" }
const _hoisted_94 = {
  key: 0,
  class: "text-dark mb-0"
}
const _hoisted_95 = {
  key: 1,
  class: "text-dark mb-0"
}
const _hoisted_96 = { class: "mb-3" }
const _hoisted_97 = {
  key: 0,
  class: "text-dark mb-0"
}
const _hoisted_98 = {
  key: 1,
  class: "text-dark"
}
const _hoisted_99 = {
  key: 3,
  class: "text-success mb-0"
}
const _hoisted_100 = {
  key: 4,
  class: "text-success mb-0"
}
const _hoisted_101 = { class: "px-4 pb-4 d-flex flex-column" }
const _hoisted_102 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_103 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-pdf mr-2" }, null, -1))
const _hoisted_105 = { class: "lead mb-0" }
const _hoisted_106 = { class: "row mb-4" }
const _hoisted_107 = { class: "col" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col" }
const _hoisted_110 = { class: "flex-grow-1" }
const _hoisted_111 = { class: "m-0" }
const _hoisted_112 = { class: "font-weight-bold" }
const _hoisted_113 = { class: "m-0" }
const _hoisted_114 = { class: "font-weight-bold" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "col" }
const _hoisted_117 = { class: "flex-grow-1" }
const _hoisted_118 = { class: "m-0" }
const _hoisted_119 = { class: "font-weight-bold" }
const _hoisted_120 = { class: "m-0" }
const _hoisted_121 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_translate = _resolveComponent("translate")!
  const _component_SidebarLink = _resolveComponent("SidebarLink")!
  const _component_Message = _resolveComponent("Message")!
  const _component_OfferDetails = _resolveComponent("OfferDetails")!
  const _component_AuditLog = _resolveComponent("AuditLog")!
  const _component_RoomDetails = _resolveComponent("RoomDetails")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MessageList = _resolveComponent("MessageList")!
  const _component_ProjectDocuments = _resolveComponent("ProjectDocuments")!
  const _component_ProjectStages = _resolveComponent("ProjectStages")!
  const _component_ProjectDetails = _resolveComponent("ProjectDetails")!
  const _component_OrganizationPicker = _resolveComponent("OrganizationPicker")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TipTapTextArea = _resolveComponent("TipTapTextArea")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_UserPicker = _resolveComponent("UserPicker")!

  return (!_ctx.project?.data || _ctx.project.call?.loading)
    ? (_openBlock(), _createBlock(_component_ProgressBar, {
        key: 0,
        mode: "indeterminate"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.childRoute1 || _ctx.room || [ 'teilnehmer', 'bieter', 'bewerber', 'dokumente' ].includes(_ctx.childRoute1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_ctx.rpcClient.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    ((_ctx.lotsWithFirstRoundActive || _ctx.lotsWithLaterRoundActive) && _ctx.offer && !_ctx.offer.stage)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 0,
                          closable: true,
                          class: "mt-0 mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("p", _hoisted_5, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sie haben sich für die Teilnahme an diesem Verfahren registriert, Ihren Teilnahmeantrag jedoch noch nicht eingereicht. Wechseln Sie zum Menüpunkt \"Teilnahmeantrag\", um Ihren Teilnahmeantrag hochzuladen und bestätigen Sie die Einreichung mit \"Teilnahmeantrag einreichen\".")
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_ctx.rpcClient.fullyLoggedIn && _ctx.offer)
                                ? (_openBlock(), _createBlock(_component_SidebarLink, {
                                    key: 0,
                                    class: "px-4 py-2",
                                    link: { to: '/projekte/' + _ctx.projectId + '/bewerbung', label: _ctx.i18n.$gettext('Teilnahmeantrag') }
                                  }, null, 8, ["link"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.projectInfo.stage === 6 && _ctx.offer?.stage === 4)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 1,
                          closable: true,
                          class: "mt-0 mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sie wurden zur Angebots-Abgabe eingeladen.")
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.projectInfo.stage === 6 && _ctx.offer?.stage === 5)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 2,
                          closable: true,
                          class: "mt-0 mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", _hoisted_9, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Achtung: Sie haben Ihr Angebot noch nicht eingereicht.")
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_ctx.rpcClient.fullyLoggedIn && _ctx.offers && !_ctx.offers.call?.loading && _ctx.offers?.data?.find(o => o.stage >= 5))
                                ? (_openBlock(), _createBlock(_component_SidebarLink, {
                                    key: 0,
                                    class: "px-4 py-2",
                                    link: { to: '/projekte/' + _ctx.projectId + '/angebot', label: _ctx.i18n.$gettext('Angebotsdokumente') }
                                  }, null, 8, ["link"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }))
                      : (_ctx.project.currentApplicationRound > 1 && !_ctx.offer && _ctx.lotsWithCanApply.length)
                        ? (_openBlock(), _createBlock(_component_Message, {
                            key: 3,
                            closable: false,
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("p", _hoisted_11, [
                                  _createVNode(_component_translate, {
                                    "translate-params": { round: _ctx.project.currentApplicationRound - 1 }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Bei dieser Ausschreibung handelt es sich um ein Dauerverhandlungsverfahren. Sie können Ihren Teilnahmeantrag in Warteraum/Runde %{ round } einreichen. Ihr Teilnahmeantrag wird berücksichtigt, falls in keiner vorangehenden Runde ein Zuschlag erteilt wird.")
                                    ]),
                                    _: 1
                                  }, 8, ["translate-params"])
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.lotsWithCanOpenSecondStep.length && _ctx.lotsWithCanOpenSecondStep[0].stage === 3)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 0,
                          closable: true,
                          class: "mt-0 mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, [
                                _createVNode(_component_translate, {
                                  "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Die Öffnung der Teilnahmeanträge wurde begonnen von %{ name } am %{ date }.")
                                  ]),
                                  _: 1
                                }, 8, ["translate-params"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : (_ctx.lotsWithCanOpenSecondStep.length && _ctx.lotsWithCanOpenSecondStep[0].stage === 6)
                        ? (_openBlock(), _createBlock(_component_Message, {
                            key: 1,
                            closable: true,
                            class: "mt-0 mb-4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("p", _hoisted_16, [
                                  _createVNode(_component_translate, {
                                    "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Die Öffnung der Angebote wurde begonnen von %{ name } am %{ date }.")
                                    ]),
                                    _: 1
                                  }, 8, ["translate-params"])
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : (_ctx.projectInfo.openingInProgress && _ctx.projectInfo.openUser === _ctx.rpcClient.session?.user?.email && _ctx.projectInfo.stage === 3)
                          ? (_openBlock(), _createBlock(_component_Message, {
                              key: 2,
                              closable: true,
                              class: "mt-0 mb-4"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("p", _hoisted_18, [
                                    _createVNode(_component_translate, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Die Öffnung der Teilnahmeanträge wurde von Ihnen begonnen am")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.projectInfo.openDateText) + ". ", 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : (_ctx.projectInfo.openingInProgress && _ctx.projectInfo.openUser === _ctx.rpcClient.session?.user?.email && _ctx.projectInfo.stage === 6)
                            ? (_openBlock(), _createBlock(_component_Message, {
                                key: 3,
                                closable: true,
                                class: "mt-0 mb-4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("p", _hoisted_20, [
                                      _createVNode(_component_translate, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Die Öffnung der Angebote wurde von Ihnen begonnen am")
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.projectInfo.openDateText) + ". ", 1)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          (_ctx.isProjectEditor && _ctx.organizationId && _ctx.offer)
            ? (_openBlock(), _createBlock(_component_OfferDetails, {
                key: 'organization-' + _ctx.organizationId,
                offer: _ctx.offer,
                "project-stage": _ctx.projectInfo.stage || 0,
                onHide: _ctx.closeOrganizationDetails
              }, null, 8, ["offer", "project-stage", "onHide"]))
            : (_ctx.childRoute1 === 'audit-log' && _ctx.isProjectOrSystemAdmin)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.childRoute1 }, [
                  _createVNode(_component_AuditLog, { "project-id": _ctx.projectId }, null, 8, ["project-id"])
                ]))
              : (_ctx.childRoute1 === 'datenraum')
                ? (_openBlock(), _createElementBlock("div", { key: _ctx.childRoute1 }, [
                    (_ctx.room)
                      ? (_openBlock(), _createBlock(_component_RoomDetails, {
                          key: 0,
                          room: _ctx.room,
                          "project-id": _ctx.projectId,
                          disabled: _ctx.roomDisabled(_ctx.room),
                          "linked-properties": _ctx.linkedProperties
                        }, null, 8, ["room", "project-id", "disabled", "linked-properties"]))
                      : (_openBlock(), _createBlock(_component_LoginForm, {
                          key: 1,
                          visible: !_ctx.rpcClient.fullyLoggedIn && !_ctx.rpcClient.needsTwoFactorConfirm
                        }, null, 8, ["visible"]))
                  ]))
                : (_ctx.childRoute1 === 'bewerbung' && !_ctx.rpcClient.isInternalUser && _ctx.offer)
                  ? (_openBlock(), _createElementBlock("div", { key: _ctx.childRoute1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lots.filter(l => !!l.lotOffer), (lot, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass({ 'mb-4': i < _ctx.lots.length - 1, 'card': _ctx.hasLots, 'p-4': _ctx.hasLots })
                        }, [
                          (_ctx.hasLots)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_22, _toDisplayString(lot.name), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.lotsWithFirstRoundActive.includes(lot) && !_ctx.lotsWithLaterRoundActive.includes(lot) && !lot.lotOffer.stage)
                            ? (_openBlock(), _createBlock(_component_Message, {
                                key: 1,
                                closable: false,
                                class: "mt-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_translate, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Für dieses Los können derzeit keine Teilnahmeanträge eingereicht werden.")
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : (!_ctx.lotsWithFirstRoundActive.includes(lot) && !_ctx.lotsWithLaterRoundActive.includes(lot))
                              ? (_openBlock(), _createBlock(_component_Message, {
                                  key: 2,
                                  closable: false,
                                  class: "mt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_translate, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ihr Teilnahmeantrag wurde eingereicht.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (!lot.lotOffer.stage)
                                ? (_openBlock(), _createBlock(_component_Message, {
                                    key: 3,
                                    closable: false,
                                    class: "mt-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("p", null, [
                                          _createVNode(_component_translate, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Ihr Teilnahmeantrag wurde noch nicht abgesendet. Nachdem Sie alle Dokumente hochgeladen haben, klicken Sie auf den Button \"Absenden\", um den Teilnahmeantrag einzureichen.")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createVNode(_component_Button, {
                                          class: "flex-shrink-0 p-button-success",
                                          onClick: ($event: any) => (_ctx.finalizeOffer(lot.lotOffer))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_translate, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Teilnahmeantrag einreichen")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_Message, {
                                    key: 4,
                                    closable: false,
                                    class: "mt-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("p", null, [
                                          _createVNode(_component_translate, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Ihr Teilnahmeantrag wurde eingereicht. Falls Sie Änderungen an Ihren Dokumenten vornehmen, oder sich nicht auf diese Ausschreibung bewerben möchten, klicken Sie auf den Button \"Teilnahmeantrag zurückziehen\". Sie können dann weitere Dokumente hinzufügen oder vorhandene Dokumente ersetzen und Ihren Teilnahmeantrag erneut absenden.")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createVNode(_component_Button, {
                                          class: "flex-shrink-0 p-button-success",
                                          onClick: ($event: any) => (_ctx.withdrawOffer(lot.lotOffer))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_translate, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Teilnahmeantrag zurückziehen")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomsByOfferId(lot.lotOffer?.id).filter(r => (r.stage || 0) <= 4), (room) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'room-' + room.id,
                              class: "mb-4"
                            }, [
                              _createVNode(_component_RoomDetails, {
                                room: room,
                                "project-id": _ctx.projectId,
                                disabled: _ctx.roomDisabled(room)
                              }, null, 8, ["room", "project-id", "disabled"])
                            ]))
                          }), 128))
                        ], 2))
                      }), 256))
                    ]))
                  : (_ctx.childRoute1 === 'angebot' && !_ctx.rpcClient.isInternalUser && _ctx.projectInfo.stage >= 6 && _ctx.offer)
                    ? (_openBlock(), _createElementBlock("div", { key: _ctx.childRoute1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lots.filter(l => !!l.lotOffer), (lot, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass({ 'mb-4': i < _ctx.lots.length - 1, 'card': _ctx.hasLots, 'p-4': _ctx.hasLots })
                          }, [
                            (_ctx.hasLots)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_27, _toDisplayString(lot.name), 1))
                              : _createCommentVNode("", true),
                            (!lot.canOffer && (lot.lotOffer?.stage || 0) < 6)
                              ? (_openBlock(), _createBlock(_component_Message, {
                                  key: 1,
                                  closable: false,
                                  class: "mt-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_translate, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Für dieses Los können Sie derzeit kein Angebot einreichen.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : (!lot.canOffer)
                                ? (_openBlock(), _createBlock(_component_Message, {
                                    key: 2,
                                    closable: false,
                                    class: "mt-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("p", null, [
                                          _createVNode(_component_translate, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Ihr Angebot wurde eingereicht.")
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : (lot.lotOffer.stage < 6)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 3,
                                      closable: false,
                                      class: "mt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_translate, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Ihr Angebot wurde noch nicht abgesendet. Nachdem Sie alle Dokumente hochgeladen haben, klicken Sie auf den Button \"Absenden\", um das Angebot einzureichen.")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_Button, {
                                            class: "flex-shrink-0 p-button-success",
                                            onClick: ($event: any) => (_ctx.finalizeOffer(lot.lotOffer))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_translate, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Angebot einreichen")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_Message, {
                                      key: 4,
                                      closable: false,
                                      class: "mt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_translate, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Ihr Angebot wurde eingereicht. Falls Sie Änderungen an Ihrem Angebot vornehmen, oder kein Angebot abgeben möchten, klicken Sie auf den Button \"Angebot zurückziehen\". Sie können dann weitere Dokumente hinzufügen oder vorhandene Dokumente ersetzen und Ihr Angebot erneut absenden.")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_Button, {
                                            class: "flex-shrink-0 p-button-success",
                                            onClick: ($event: any) => (_ctx.withdrawOffer(lot.lotOffer))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_translate, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Angebot zurückziehen")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomsByOfferId(lot.lotOffer?.id).filter(r => r.stage === 7), (room) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'room-' + room.id,
                                class: "mb-4"
                              }, [
                                _createVNode(_component_RoomDetails, {
                                  room: room,
                                  "project-id": _ctx.projectId,
                                  disabled: _ctx.roomDisabled(room)
                                }, null, 8, ["room", "project-id", "disabled"])
                              ]))
                            }), 128))
                          ], 2))
                        }), 256))
                      ]))
                    : (_ctx.childRoute1 === 'verhandlung' && _ctx.projectInfo.stage >= 4)
                      ? (_openBlock(), _createElementBlock("div", { key: _ctx.childRoute1 }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h4", null, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Nachrichten")
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_MessageList, {
                              "project-id": _ctx.projectInfo.id,
                              offer: _ctx.offer
                            }, null, 8, ["project-id", "offer"])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("h4", _hoisted_35, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Dokumente")
                                  ]),
                                  _: 1
                                })
                              ]),
                              (!_ctx.projectInfo.archived && _ctx.isProjectEditor && _ctx.projectInfo.stage < 6 && _ctx.offers && !_ctx.offers.call?.loading && _ctx.offers?.data?.find(o => o.stage >= 3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-plus",
                                      label: _ctx.i18n.$gettext('Datenraum hinzufügen'),
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateRoomDialog = true))
                                    }, null, 8, ["label"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.rooms?.data || []).filter(r => r.stage === 5 && !r.organizationId && !r.offerId), (room) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mb-4",
                                key: 'room-' + room.id
                              }, [
                                _createVNode(_component_RoomDetails, {
                                  room: room,
                                  "project-id": _ctx.projectId,
                                  disabled: _ctx.roomDisabled(room),
                                  "linked-properties": _ctx.linkedProperties
                                }, null, 8, ["room", "project-id", "disabled", "linked-properties"])
                              ]))
                            }), 128)),
                            (!_ctx.rpcClient.isInternalUser)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizationSpecificRooms.filter(r => r.stage === 5), (room) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "mb-4",
                                      key: 'room-' + room.id
                                    }, [
                                      _createVNode(_component_RoomDetails, {
                                        room: room,
                                        "project-id": _ctx.projectId,
                                        disabled: _ctx.roomDisabled(room)
                                      }, null, 8, ["room", "project-id", "disabled"])
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.rooms?.data || []).filter(r => r.stage === 5 && !r.organizationId && r.offerId), (room) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "mb-4",
                                      key: 'room-' + room.id
                                    }, [
                                      _createVNode(_component_RoomDetails, {
                                        room: room,
                                        "project-id": _ctx.projectId,
                                        disabled: _ctx.roomDisabled(room)
                                      }, null, 8, ["room", "project-id", "disabled"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_ctx.childRoute1 === 'nachrichten')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: _ctx.childRoute1,
                            class: "card bg-white p-5"
                          }, [
                            _createElementVNode("h4", null, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Nachrichten")
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_MessageList, {
                              "project-id": _ctx.projectInfo.id,
                              offer: _ctx.offer
                            }, null, 8, ["project-id", "offer"])
                          ]))
                        : (_ctx.childRoute1 === 'dokumente')
                          ? (_openBlock(), _createBlock(_component_ProjectDocuments, {
                              project: _ctx.projectInfo,
                              key: _ctx.childRoute1,
                              "linked-properties": _ctx.linkedProperties
                            }, null, 8, ["project", "linked-properties"]))
                          : ([ 'teilnehmer', 'bieter', 'bewerber' ].includes(_ctx.childRoute1) && !_ctx.childId1)
                            ? (_openBlock(), _createBlock(_component_ProjectStages, {
                                project: _ctx.projectInfo,
                                key: _ctx.childRoute1
                              }, null, 8, ["project"]))
                            : (_openBlock(), _createBlock(_component_ProjectDetails, {
                                project: _ctx.projectInfo,
                                offer: _ctx.offer,
                                key: _ctx.projectInfo.id
                              }, null, 8, ["project", "offer"]))
        ]),
        (_ctx.isProjectEditor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Einladung'),
                visible: _ctx.showInvitationDialog,
                "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showInvitationDialog) = $event)),
                onSubmit: _withModifiers(_ctx.inviteUsers, ["prevent"]),
                modal: "",
                dismissableMask: "",
                style: {"min-height":"50vh"}
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text mr-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showInvitationDialog = false))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    type: "submit",
                    label: _ctx.i18n.$gettext('Senden'),
                    icon: "pi pi-check",
                    class: "p-button-success mx-0",
                    autofocus: "",
                    disabled: !_ctx.invitedEmails?.length
                  }, null, 8, ["label", "disabled"])
                ]),
                default: _withCtx(() => [
                  (!_ctx.users.call?.loading && !_ctx.organizations.call?.loading)
                    ? (_openBlock(), _createBlock(_component_OrganizationPicker, {
                        key: 0,
                        modelValue: _ctx.invitedEmails,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invitedEmails) = $event)),
                        label: _ctx.i18n.$gettext('Einzuladende Bieter (Firmen-Name / E-Mail / Name'),
                        users: (_ctx.users.data || []),
                        organizations: (_ctx.organizations.data || [])
                      }, null, 8, ["modelValue", "label", "users", "organizations"]))
                    : (_openBlock(), _createBlock(_component_ProgressBar, {
                        key: 1,
                        mode: "indeterminate"
                      })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitedEmails, (emailAndOrganization, i) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: emailAndOrganization.email,
                      class: "mt-2"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("p", _hoisted_42, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("E-Mail:")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("p", _hoisted_43, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Unternehmen:")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("p", _hoisted_45, _toDisplayString(emailAndOrganization.email), 1),
                              _createElementVNode("p", _hoisted_46, _toDisplayString(emailAndOrganization.organizationName || ''), 1)
                            ])
                          ]),
                          _createVNode(_component_Button, {
                            class: "p-button-danger flat p-button-text",
                            icon: "pi pi-trash",
                            onClick: ($event: any) => (_ctx.invitedEmails.splice(i, 1))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["header", "visible", "onSubmit"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Ausschreibung veröffentlichen'),
                visible: _ctx.showPublicationDialog,
                "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showPublicationDialog) = $event)),
                onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.updateStage(_ctx.startOfferPhase ? 6 : (_ctx.skipApplicationPhase ? 5 : (_ctx.startApplicationPhaseWhenPublished ? 3 : 2)))), ["prevent","stop"])),
                modal: "",
                dismissableMask: "",
                style: {"min-height":"50vh"}
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_Button, {
                        label: _ctx.i18n.$gettext('Abbrechen'),
                        icon: "pi pi-times",
                        class: "p-button-text mr-2",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPublicationDialog = false))
                      }, null, 8, ["label"])
                    ]),
                    _createVNode(_component_Button, {
                      type: "submit",
                      label: _ctx.i18n.$gettext('Veröffentlichen'),
                      icon: "pi pi-check",
                      class: "p-button-success mx-0",
                      autofocus: "",
                      disabled: !_ctx.publicationDate
                    }, null, 8, ["label", "disabled"])
                  ])
                ]),
                default: _withCtx(() => [
                  (_ctx.hasRequiredIncomplete)
                    ? (_openBlock(), _createBlock(_component_Message, {
                        key: 0,
                        closable: false,
                        class: "mt-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("p", _hoisted_48, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Achtung: Nicht alle erforderlichen Felder wurden ausgefüllt. Die Veröffentlichung bei SIMAP ist nur möglich, wenn alle erforderlichen Felder ausgefüllt sind.")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.projectInfo.templateId?.startsWith('EU-'))
                    ? (_openBlock(), _createBlock(_component_Checkbox, {
                        key: 1,
                        binary: "",
                        modelValue: _ctx.publishToSIMAP,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.publishToSIMAP) = $event)),
                        label: _ctx.i18n.$gettext('Veröffentlichung bei SIMAP'),
                        disabled: _ctx.hasRequiredIncomplete,
                        name: "publishToSIMAP",
                        class: "mb-4"
                      }, null, 8, ["modelValue", "label", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.publishToSIMAP)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_49, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Die Ausschreibung wird mit Klick auf \"Veröffentlichen\" sofort auf SIMAP veröffentlicht.")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Wann soll die Veröffentlichung auf dieser Plattform erfolgen?")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_DatePicker, {
                    class: "mb-4",
                    modelValue: _ctx.publicationDate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.publicationDate) = $event)),
                    required: "",
                    showTime: "",
                    minDate: _ctx.minPublishingDate,
                    label: _ctx.i18n.$gettext('Zeitpunkt der Veröffentlichung')
                  }, null, 8, ["modelValue", "minDate", "label"]),
                  (!_ctx.projectInfo.type || _ctx.projectInfo.type === 5)
                    ? (_openBlock(), _createBlock(_component_Checkbox, {
                        key: 3,
                        binary: "",
                        modelValue: _ctx.startApplicationPhaseWhenPublished,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startApplicationPhaseWhenPublished) = $event)),
                          _cache[7] || (_cache[7] = value => { if (value) { _ctx.startOfferPhase = false; _ctx.skipApplicationPhase = false; _ctx.selectedLots = this.lots.map(l => String(l.id)) } })
                        ],
                        label: _ctx.i18n.$gettext('Teilnahmewettbewerb mit Veröffentlichung starten'),
                        name: "startApplicationPhaseWhenPublished",
                        class: "my-1"
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.type)
                    ? (_openBlock(), _createBlock(_component_Checkbox, {
                        key: 4,
                        binary: "",
                        modelValue: _ctx.skipApplicationPhase,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((_ctx.skipApplicationPhase) = $event)),
                          _cache[9] || (_cache[9] = value => { if (value) { _ctx.startOfferPhase = false; _ctx.startApplicationPhaseWhenPublished = false; _ctx.selectedLots = this.lots.map(l => String(l.id)) } })
                        ],
                        label: _ctx.i18n.$gettext('Verhandlungsphase mit Veröffentlichung starten'),
                        name: "skipApplicationPhase",
                        class: "my-1"
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.type)
                    ? (_openBlock(), _createBlock(_component_Checkbox, {
                        key: 5,
                        binary: "",
                        modelValue: _ctx.startOfferPhase,
                        "onUpdate:modelValue": [
                          _cache[10] || (_cache[10] = ($event: any) => ((_ctx.startOfferPhase) = $event)),
                          _cache[11] || (_cache[11] = value => { if (value) { _ctx.skipApplicationPhase = false; _ctx.startApplicationPhaseWhenPublished = false; _ctx.selectedLots = this.lots.map(l => String(l.id)) } })
                        ],
                        label: _ctx.i18n.$gettext('Angebotsphase mit Veröffentlichung starten'),
                        name: "startOfferPhase",
                        class: "my-1^"
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasLots && (_ctx.startOfferPhase || _ctx.skipApplicationPhase || _ctx.startApplicationPhaseWhenPublished))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        (_ctx.startApplicationPhaseWhenPublished)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Für welche Lose soll der Teilnahmewettbewerb bei Veröffentlichung gestartet werden?")
                                ]),
                                _: 1
                              })
                            ]))
                          : (_ctx.skipApplicationPhase)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Für welche Lose soll die Verhandlungsphase bei Veröffentlichung gestartet werden?")
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                        (_ctx.startOfferPhase)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Für welche Lose soll die Angebotsphase bei Veröffentlichung gestartet werden?")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lots, (lot) => {
                          return (_openBlock(), _createBlock(_component_Checkbox, {
                            id: String(lot.id),
                            value: String(lot.id),
                            label: lot.name,
                            modelValue: _ctx.selectedLots,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedLots) = $event))
                          }, null, 8, ["id", "value", "label", "modelValue"]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Teilnahmewettbewerb starten'),
                visible: _ctx.showApplicationPhaseDialog,
                "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showApplicationPhaseDialog) = $event)),
                modal: "",
                dismissableMask: ""
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text mr-2",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showApplicationPhaseDialog = false))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Starten'),
                    icon: "pi pi-check",
                    class: "p-button-success mx-0",
                    autofocus: "",
                    disabled: _ctx.hasLots && !_ctx.selectedLots.length,
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateStage(3)))
                  }, null, 8, ["label", "disabled"])
                ]),
                default: _withCtx(() => [
                  (_ctx.hasLots)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("p", _hoisted_56, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Wählen Sie die Lose, für die der Teilnahmewettbewerb gestartet werden soll.")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("p", _hoisted_57, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Der Teilnahmewettbewerb startet für die ausgewählten Lose mit Klick auf \"Starten\".")
                            ]),
                            _: 1
                          })
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanStartApplicationPhase, (lot) => {
                          return (_openBlock(), _createBlock(_component_Checkbox, {
                            id: String(lot.id),
                            value: String(lot.id),
                            label: lot.name,
                            modelValue: _ctx.selectedLots,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedLots) = $event))
                          }, null, 8, ["id", "value", "label", "modelValue"]))
                        }), 256))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_58, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Der Teilnahmewettbewerb startet mit Klick auf \"Starten\".")
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Teilnahmeanträge öffnen'),
                visible: _ctx.showOpenApplicationsDialog,
                "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showOpenApplicationsDialog) = $event)),
                modal: "",
                dismissableMask: "",
                onSubmit: _withModifiers(_ctx.openApplications, ["prevent","stop"]),
                onHide: _cache[26] || (_cache[26] = ($event: any) => (_ctx.password = ''))
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text mr-2",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showOpenApplicationsDialog = false))
                  }, null, 8, ["label"]),
                  (!_ctx.projectInfo.openingInProgress)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        type: "submit",
                        label: _ctx.i18n.$gettext('Bestätigen'),
                        icon: "pi pi-check",
                        class: "p-button-success p-button-text border-success bg-white mx-0",
                        autofocus: "",
                        disabled: !_ctx.password || (_ctx.hasLots && !_ctx.selectedLots?.length)
                      }, null, 8, ["label", "disabled"]))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        type: "submit",
                        label: _ctx.i18n.$gettext('Öffnen'),
                        icon: "pi pi-check",
                        class: "p-button-success mx-0",
                        autofocus: "",
                        disabled: !_ctx.password || (_ctx.hasLots && !_ctx.selectedLots?.length)
                      }, null, 8, ["label", "disabled"]))
                ]),
                default: _withCtx(() => [
                  (_ctx.projectInfo.openingInProgress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (_ctx.hasLots)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createVNode(_component_translate, {
                                "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Die Öffnung der Teilnahmeanträge wurde begonnen von %{ name } am %{ date } für diese Lose:")
                                ]),
                                _: 1
                              }, 8, ["translate-params"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanOpenSecondStep, (lot) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createVNode(_component_Checkbox, {
                                    id: String(lot.id),
                                    value: String(lot.id),
                                    label: lot.name,
                                    modelValue: _ctx.selectedLots,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedLots) = $event)),
                                    disabled: ""
                                  }, null, 8, ["id", "value", "label", "modelValue"]),
                                  (_ctx.lotsWithCanOpenNextRound.includes(lot))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_61, [
                                        _createVNode(_component_translate, {
                                          "translate-params": { name: lot.name, round: lot.nextOpenableRound }
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Alle Bewerberbungen/Angebote für das Los %{ name } werden abgelehnt und die Teilnahmeanträge des Warteraums %{ round } werden geöffnet.")
                                          ]),
                                          _: 2
                                        }, 1032, ["translate-params"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_62, [
                              _createVNode(_component_translate, {
                                "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Die Öffnung der Teilnahmeanträge wurde begonnen von %{ name } am %{ date }.")
                                ]),
                                _: 1
                              }, 8, ["translate-params"])
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        (_ctx.hasLots)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _createElementVNode("p", null, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Wählen Sie die Lose, deren Teilnahmeanträge Sie öffnen möchten.")
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanOpenFirstRound, (lot) => {
                                return (_openBlock(), _createBlock(_component_Checkbox, {
                                  id: String(lot.id),
                                  value: String(lot.id),
                                  label: lot.name,
                                  modelValue: _ctx.selectedLots,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedLots) = $event))
                                }, null, 8, ["id", "value", "label", "modelValue"]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hasLots && _ctx.lotsWithCanOpenNextRound.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createElementVNode("p", null, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Wählen Sie die Lose, deren Warteräume Sie öffnen möchten.")
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanOpenNextRound, (lot) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createVNode(_component_Checkbox, {
                                    id: String(lot.id),
                                    value: String(lot.id),
                                    label: lot.name,
                                    modelValue: _ctx.selectedLots,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedLots) = $event))
                                  }, null, 8, ["id", "value", "label", "modelValue"]),
                                  (_ctx.selectedLots?.includes(String(lot.id)))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_66, [
                                        _createVNode(_component_translate, {
                                          "translate-params": { name: lot.name, round: lot.nextOpenableRound }
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Alle Bewerberbungen/Angebote für das Los %{ name } werden abgelehnt und die Teilnahmeanträge des Warteraums %{ round } werden geöffnet.")
                                          ]),
                                          _: 2
                                        }, 1032, ["translate-params"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ])),
                  (!_ctx.hasLots && _ctx.projectInfo.type === 5 && !_ctx.projectInfo.canOpenFirstRound && (_ctx.projectInfo.nextOpenableRound || 0) > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("p", _hoisted_68, [
                          _createVNode(_component_translate, {
                            "translate-params": { name: _ctx.projectInfo.name, round: _ctx.projectInfo.nextOpenableRound }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Alle Bewerberbungen/Angebote für das Los %{ name } werden abgelehnt und die Teilnahmeanträge des Warteraums %{ round } werden geöffnet.")
                            ]),
                            _: 1
                          }, 8, ["translate-params"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.canOpenSecondStep && _ctx.projectInfo.openUser !== _ctx.rpcClient.session.user?.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Bitte geben Sie Ihr Passwort ein, um mit der Öffnung der Teilnahmeanträge zu beginnen.")
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.projectInfo.openDateText && _ctx.projectInfo.openUser === _ctx.rpcClient.session.user?.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_70, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Die Öffnung wurde von Ihnen begonnen am")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.projectInfo.openDateText) + ".", 1),
                          _hoisted_71,
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Geben Sie Ihr Passwort ein, um die Zeituhr neu zu starten.")
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_72, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Bitte geben Sie Ihr Passwort ein, um die Teilnahmeanträge zu öffnen.")
                            ]),
                            _: 1
                          })
                        ])),
                  _createVNode(_component_AnimatedInput, {
                    class: "mb-3",
                    type: "password",
                    label: _ctx.i18n.$gettext('Passwort'),
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.password) = $event)),
                    modelModifiers: { lazy: true, trim: true },
                    required: ""
                  }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
              }, 8, ["header", "visible", "onSubmit"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Angebote öffnen'),
                visible: _ctx.showOpenOffersDialog,
                "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.showOpenOffersDialog) = $event)),
                modal: "",
                dismissableMask: "",
                onSubmit: _withModifiers(_ctx.openOffers, ["prevent","stop"]),
                onHide: _cache[32] || (_cache[32] = ($event: any) => (_ctx.password = ''))
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text mr-2",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showOpenOffersDialog = false))
                  }, null, 8, ["label"]),
                  (!_ctx.projectInfo.openingInProgress)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        type: "submit",
                        label: _ctx.i18n.$gettext('Bestätigen'),
                        icon: "pi pi-check",
                        class: "p-button-success p-button-text border-success bg-white mx-0",
                        autofocus: "",
                        disabled: !_ctx.password || (_ctx.hasLots && !_ctx.selectedLots?.length)
                      }, null, 8, ["label", "disabled"]))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        type: "submit",
                        label: _ctx.i18n.$gettext('Öffnen'),
                        icon: "pi pi-check",
                        class: "p-button-success mx-0",
                        autofocus: "",
                        disabled: !_ctx.password || (_ctx.hasLots && !_ctx.selectedLots?.length)
                      }, null, 8, ["label", "disabled"]))
                ]),
                default: _withCtx(() => [
                  (_ctx.projectInfo.openingInProgress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        (_ctx.hasLots)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              _createVNode(_component_translate, {
                                "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Die Öffnung der Angebote wurde begonnen von %{ name } am %{ date } für diese Lose:")
                                ]),
                                _: 1
                              }, 8, ["translate-params"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanOpenSecondStep, (lot) => {
                                return (_openBlock(), _createBlock(_component_Checkbox, {
                                  id: String(lot.id),
                                  value: String(lot.id),
                                  label: lot.name,
                                  modelValue: _ctx.selectedLots,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.selectedLots) = $event)),
                                  disabled: ""
                                }, null, 8, ["id", "value", "label", "modelValue"]))
                              }), 256))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_75, [
                              _createVNode(_component_translate, {
                                "translate-params": { name: _ctx.projectInfo.openedByText, date: _ctx.projectInfo.openDateText }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Die Öffnung der Angebote wurde begonnen von %{ name } am %{ date }.")
                                ]),
                                _: 1
                              }, 8, ["translate-params"])
                            ]))
                      ]))
                    : (_ctx.hasLots)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _createElementVNode("p", null, [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Wählen Sie die Lose, deren Angebote Sie öffnen möchten.")
                              ]),
                              _: 1
                            })
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanOpenOffers, (lot) => {
                            return (_openBlock(), _createBlock(_component_Checkbox, {
                              id: String(lot.id),
                              value: String(lot.id),
                              label: lot.name,
                              modelValue: _ctx.selectedLots,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedLots) = $event))
                            }, null, 8, ["id", "value", "label", "modelValue"]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true),
                  (!_ctx.projectInfo.canOpenSecondStep && _ctx.projectInfo.openUser !== _ctx.rpcClient.session.user?.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_77, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Bitte geben Sie Ihr Passwort ein, um mit der Öffnung der Angebote zu beginnen.")
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.projectInfo.openDateText && _ctx.projectInfo.openUser === _ctx.rpcClient.session.user?.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_78, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Die Öffnung wurde von Ihnen begonnen am")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.projectInfo.openDateText) + ".", 1),
                          _hoisted_79,
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Geben Sie Ihr Passwort ein, um die Zeituhr neu zu starten.")
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_80, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Bitte geben Sie Ihr Passwort ein, um die Angebote zu öffnen.")
                            ]),
                            _: 1
                          })
                        ])),
                  _createVNode(_component_AnimatedInput, {
                    class: "mb-3",
                    type: "password",
                    label: _ctx.i18n.$gettext('Passwort'),
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.password) = $event)),
                    modelModifiers: { lazy: true, trim: true },
                    required: ""
                  }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
              }, 8, ["header", "visible", "onSubmit"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Angebotsphase starten'),
                visible: _ctx.showOfferPhaseDialog,
                "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.showOfferPhaseDialog) = $event)),
                modal: "",
                dismissableMask: ""
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text",
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showOfferPhaseDialog = false))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Speichern'),
                    icon: "pi pi-check",
                    autofocus: "",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.updateStage(6)))
                  }, null, 8, ["label"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (!_ctx.hasLots)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_81, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Die Angebotsphase startet mit Klick auf \"Speichern\".")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.hasLots)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_82, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Diese Unternehmen werden als bevorzugte Bieter zur Angebots-Abgabe aufgefordert:")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanStartOfferPhase, (lot) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        (_ctx.hasLots)
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 0,
                              id: String(lot.id),
                              value: String(lot.id),
                              label: lot.name,
                              modelValue: _ctx.selectedLots,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.selectedLots) = $event))
                            }, null, 8, ["id", "value", "label", "modelValue"]))
                          : _createCommentVNode("", true),
                        (!_ctx.hasLots || _ctx.selectedLots.includes(String(lot.id)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                              (_ctx.hasLots)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_85, [
                                    _createVNode(_component_translate, {
                                      "translate-params": { name: lot.name }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Wählen Sie die Unternehmen, die für das Los %{ name } zur Angebots-Abgabe zugelassen werden:")
                                      ]),
                                      _: 2
                                    }, 1032, ["translate-params"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(), _createBlock(_component_Multiselect, {
                                key: lot.id + '-offerSelect',
                                label: _ctx.i18n.$gettext('Unternehmen'),
                                options: lot.offersByRound[lot.lastOpenedRound].filter(o => o.lotOffer.stage === 3 && !!o.offer.organization),
                                "option-label": "offer.organization.name",
                                "option-value": "lotOffer.id",
                                modelValue: _ctx.acceptedOffers[lot.id],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.acceptedOffers[lot.id]) = $event),
                                filter: "",
                                showClear: ""
                              }, null, 8, ["label", "options", "modelValue", "onUpdate:modelValue"]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Verhandlungsphase starten'),
                visible: _ctx.showNegotiationPhaseDialog,
                "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.showNegotiationPhaseDialog) = $event)),
                modal: "",
                dismissableMask: ""
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text",
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showNegotiationPhaseDialog = false))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Speichern'),
                    icon: "pi pi-check",
                    autofocus: "",
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.updateStage(5)))
                  }, null, 8, ["label"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (!_ctx.hasLots)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_86, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Die Verhandlungsphase startet mit Klick auf \"Speichern\".")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.hasLots)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Diese Unternehmen werden als bevorzugte Bieter zur Verhandlung zugelassen:")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lotsWithCanStartNegotiationPhase, (lot) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        (_ctx.hasLots)
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 0,
                              id: String(lot.id),
                              value: String(lot.id),
                              label: lot.name,
                              modelValue: _ctx.selectedLots,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedLots) = $event))
                            }, null, 8, ["id", "value", "label", "modelValue"]))
                          : _createCommentVNode("", true),
                        (!_ctx.hasLots || _ctx.selectedLots.includes(String(lot.id)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              (_ctx.hasLots)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_90, [
                                    _createVNode(_component_translate, {
                                      "translate-params": { name: lot.name }
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Wählen Sie die Unternehmen, die für das Los %{ name } zur Verhandlung zugelassen werden:")
                                      ]),
                                      _: 2
                                    }, 1032, ["translate-params"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(), _createBlock(_component_Multiselect, {
                                key: lot.id + '-offerSelect',
                                label: _ctx.i18n.$gettext('Unternehmen'),
                                options: lot.offersByRound[lot.lastOpenedRound].filter(o => o.lotOffer.stage === 1 && !!o.offer.organization),
                                "option-label": "offer.organization.name",
                                "option-value": "lotOffer.id",
                                modelValue: _ctx.acceptedOffers[lot.id],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.acceptedOffers[lot.id]) = $event),
                                filter: "",
                                showClear: ""
                              }, null, 8, ["label", "options", "modelValue", "onUpdate:modelValue"]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ]),
                _: 1
              }, 8, ["header", "visible"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Dialog, {
          header: _ctx.i18n.$gettext('Datenraum erstellen'),
          visible: _ctx.showCreateRoomDialog,
          "onUpdate:visible": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.showCreateRoomDialog) = $event)),
          onHide: _ctx.resetCreateRoomDialog,
          modal: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.i18n.$gettext('Abbrechen'),
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _ctx.resetCreateRoomDialog
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_Button, {
              label: _ctx.i18n.$gettext('Speichern'),
              icon: "pi pi-check",
              autofocus: "",
              disabled: !_ctx.roomName,
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.createRoom(5)))
            }, null, 8, ["label", "disabled"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AnimatedInput, {
              class: "mb-4",
              modelValue: _ctx.roomName,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.roomName) = $event)),
              "auto-resize": "",
              label: _ctx.i18n.$gettext('Datenraum-Name')
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_TipTapTextArea, {
              ref: "editor",
              type: "text",
              placeholder: _ctx.i18n.$gettext('Beschreibung / Hinweis-Text zum Datenraum'),
              modelValue: _ctx.roomDescription,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.roomDescription) = $event)),
              modelModifiers: { lazy: true, trim: true },
              required: ""
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["header", "visible", "onHide"]),
        (_openBlock(), _createBlock(_Teleport, { to: "#sidebar" }, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("h6", _hoisted_92, _toDisplayString(_ctx.projectInfo.name), 1),
            _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.projectTypeName), 1),
            (_ctx.projectInfo.published && _ctx.dayjs(_ctx.projectInfo.published).isAfter(_ctx.dayjs()))
              ? (_openBlock(), _createElementBlock("p", _hoisted_94, [
                  _createVNode(_component_translate, { class: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Veröffentlichung:")
                    ]),
                    _: 1
                  }),
                  _createTextVNode("  " + _toDisplayString(_ctx.dayjs(_ctx.projectInfo.published).format('LLL')), 1)
                ]))
              : (_ctx.projectInfo.published)
                ? (_openBlock(), _createElementBlock("p", _hoisted_95, [
                    _createVNode(_component_translate, { class: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Veröffentlicht:")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("  " + _toDisplayString(_ctx.dayjs(_ctx.projectInfo.published).format('LLL')), 1)
                  ]))
                : _createCommentVNode("", true),
            (_ctx.allLotsSameDates)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList([ _ctx.lots[0] ], (lot) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    (lot.applicationDeadline)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_97, [
                          _createVNode(_component_translate, { class: "font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Teilnahmefrist:")
                            ]),
                            _: 1
                          }),
                          _createTextVNode("  " + _toDisplayString(_ctx.dayjs(lot.applicationDeadline).format('LLL')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (lot.offerDeadline)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_98, [
                          _createVNode(_component_translate, { class: "font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Angebotsfrist:")
                            ]),
                            _: 1
                          }),
                          _createTextVNode("  " + _toDisplayString(_ctx.dayjs(lot.offerDeadline).format('LLL')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              : _createCommentVNode("", true),
            (_ctx.projectInfo.archived)
              ? (_openBlock(), _createElementBlock("p", _hoisted_99, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Diese Ausschreibung wurde archiviert.")
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.projectInfo.tags?.includes('merkliste'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_100, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Ausschreibung ist auf Ihrer Merkliste.")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_101, [
            (_ctx.isProjectEditor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  (!_ctx.projectInfo.archived && !_ctx.projectInfo.stage)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.openPublicationDialog && _ctx.openPublicationDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Ausschreibung veröffentlichen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && _ctx.projectInfo.isPublished && _ctx.canInvite)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.openInvitationDialog && _ctx.openInvitationDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Einladungen senden")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && _ctx.projectInfo.isPublished && _ctx.lotsWithCanStartApplicationPhase.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.openApplicationPhaseDialog && _ctx.openApplicationPhaseDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Teilnahmewettbewerb starten")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && _ctx.lotsWithCanOpenSecondStep.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.lotsWithCanOpenSecondStep[0].stage === 6 ? _ctx.openOpenOffersDialog() : _ctx.openOpenApplicationsDialog()))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Öffnung bestätigen")
                          ]),
                          _: 1
                        })
                      ]))
                    : (!_ctx.projectInfo.archived && !_ctx.projectInfo.openingInProgress && _ctx.lotsWithCanOpenFirstRound.length)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 4,
                          href: "javascript:",
                          class: "text-primary",
                          onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.openOpenApplicationsDialog && _ctx.openOpenApplicationsDialog(...args)))
                        }, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Teilnahmeanträge öffnen")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && _ctx.lotsWithCanStartNegotiationPhase.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 5,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.openNegotiationPhaseDialog && _ctx.openNegotiationPhaseDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Verhandlungsphase starten")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && !_ctx.projectInfo.openingInProgress && _ctx.lotsWithCanStartOfferPhase.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 6,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.openOfferPhaseDialog && _ctx.openOfferPhaseDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Angebotsphase starten")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && !_ctx.projectInfo.openingInProgress && _ctx.lotsWithCanOpenOffers.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 7,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.openOpenOffersDialog && _ctx.openOpenOffersDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Angebote öffnen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && !_ctx.projectInfo.openingInProgress && _ctx.lotsWithCanOpenNextRound.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 8,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.openOpenApplicationsDialog && _ctx.openOpenApplicationsDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Warteraum")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.lotsWithCanOpenNextRound[0].lastOpenedRound) + " ", 1),
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("öffnen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && ![ 3, 4 ].includes(_ctx.projectInfo.type) && _ctx.isProjectOrSystemAdmin)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 9,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.openAddTeamMembersDialog && _ctx.openAddTeamMembersDialog(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Sachbearbeiter hinzufügen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && !_ctx.projectInfo.stage && _ctx.isProjectOrSystemAdmin)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 10,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.$router.push('/projekte/bearbeiten/' + _ctx.projectId)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Ausschreibung bearbeiten")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.projectInfo.stage >= 2 && _ctx.projectInfo.stage < 6 && _ctx.isProjectOrSystemAdmin)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 11,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.$router.push('/projekte/bearbeiten/' + _ctx.projectId)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Änderung bekanntmachen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.projectInfo.archived && _ctx.isProjectOrSystemAdmin)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 12,
                        href: "javascript:",
                        class: "text-primary",
                        onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.cancelProject && _ctx.cancelProject(...args)))
                      }, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Ausschreibung abbrechen")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (!_ctx.rpcClient.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                    (!_ctx.projectInfo.archived && !_ctx.isOnWatchlist)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:",
                          class: "text-primary",
                          onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.addToWatchlist && _ctx.addToWatchlist(...args)))
                        }, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Auf Merkliste setzen")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.projectInfo.archived && !_ctx.offer && _ctx.lotsWithCanApply.length)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "javascript:",
                          class: "text-primary",
                          onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.createOffer && _ctx.createOffer(...args)))
                        }, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Teilnehmen")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "javascript:",
              class: "text-primary",
              onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.downloadPDF && _ctx.downloadPDF(...args)))
            }, [
              _hoisted_104,
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("PDF")
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_SidebarLink, {
            class: "px-4 py-2",
            link: { to: '/projekte/' + _ctx.projectId, hash: '#top', label: _ctx.i18n.$gettext('Details') },
            "active-without-hash": ""
          }, null, 8, ["link"]),
          _createElementVNode("div", {
            class: _normalizeClass(["collapse-menu", { show: !_ctx.childRoute1 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuStructure, (link) => {
              return (_openBlock(), _createBlock(_component_SidebarLink, {
                class: "pl-5 py-2",
                link: link
              }, null, 8, ["link"]))
            }), 256))
          ], 2),
          (_ctx.isProjectEditor && [ 0, 1, 5 ].includes(_ctx.projectInfo.type || 0))
            ? (_openBlock(), _createBlock(_component_SidebarLink, {
                key: 0,
                class: "px-4 py-2",
                link: { to: '/projekte/' + _ctx.projectId + '/teilnehmer', label: _ctx.i18n.$gettext('Teilnehmner') }
              }, null, 8, ["link"]))
            : (_ctx.isProjectEditor && _ctx.projectInfo.type === 2)
              ? (_openBlock(), _createBlock(_component_SidebarLink, {
                  key: 1,
                  class: "px-4 py-2",
                  link: { to: '/projekte/' + _ctx.projectId + '/teilnehmer', label: _ctx.i18n.$gettext('Interessenten') }
                }, null, 8, ["link"]))
              : _createCommentVNode("", true),
          _createVNode(_component_SidebarLink, {
            class: "px-4 py-2",
            link: { to: '/projekte/' + _ctx.projectId + '/dokumente', label: _ctx.i18n.$gettext('Dokumente') }
          }, null, 8, ["link"]),
          _createVNode(_component_SidebarLink, {
            class: "px-4 py-2",
            link: { to: '/projekte/' + _ctx.projectId + '/nachrichten', label: _ctx.i18n.$gettext('Nachrichten') }
          }, {
            default: _withCtx(() => [
              (_ctx.unreadMessages)
                ? (_openBlock(), _createBlock(_component_Tag, {
                    key: 0,
                    class: "ml-2",
                    value: _ctx.unreadMessages + ' ' + _ctx.i18n.$gettext('neu')
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["link"]),
          (!_ctx.rpcClient.isInternalUser && _ctx.offer && !_ctx.projectInfo.skippedPhases?.includes('3'))
            ? (_openBlock(), _createBlock(_component_SidebarLink, {
                key: 2,
                class: "px-4 py-2",
                link: { to: '/projekte/' + _ctx.projectId + '/bewerbung', label: _ctx.i18n.$gettext('Teilnahmeantrag') }
              }, null, 8, ["link"]))
            : _createCommentVNode("", true),
          (!_ctx.rpcClient.isInternalUser && _ctx.offer?.stage >= 3 && _ctx.projectInfo.stage >= 5 && !_ctx.projectInfo.skippedPhases?.includes('5'))
            ? (_openBlock(), _createBlock(_component_SidebarLink, {
                key: 3,
                class: "px-4 py-2",
                link: { to: '/projekte/' + _ctx.projectId + '/verhandlung', label: _ctx.i18n.$gettext('Verhandlung') }
              }, null, 8, ["link"]))
            : _createCommentVNode("", true),
          (!_ctx.rpcClient.isInternalUser && _ctx.offer?.stage >= 4 && _ctx.projectInfo.stage >= 6 && !_ctx.projectInfo.skippedPhases?.includes('6'))
            ? (_openBlock(), _createBlock(_component_SidebarLink, {
                key: 4,
                class: "px-4 py-2",
                link: { to: '/projekte/' + _ctx.projectId + '/angebot', label: _ctx.i18n.$gettext('Angebot') }
              }, null, 8, ["link"]))
            : _createCommentVNode("", true),
          (_ctx.isProjectEditor)
            ? (_openBlock(), _createBlock(_component_SidebarLink, {
                key: 5,
                class: "px-4 py-2",
                link: { to: '/projekte/' + _ctx.projectId + '/audit-log', label: _ctx.i18n.$gettext('Audit-Log') }
              }, null, 8, ["link"]))
            : _createCommentVNode("", true)
        ])),
        (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ])),
        _createVNode(_component_Dialog, {
          visible: _ctx.showAddTeamMembersDialog,
          "onUpdate:visible": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.showAddTeamMembersDialog) = $event)),
          modal: true,
          "close-on-escape": false,
          onHide: _ctx.closeAddTeamMembersDialog
        }, {
          header: _withCtx(() => [
            _createElementVNode("p", _hoisted_105, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Sachbearbeiter hinzufügen")
                ]),
                _: 1
              })
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.i18n.$gettext('Abbrechen'),
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _ctx.closeAddTeamMembersDialog
            }, null, 8, ["label", "onClick"]),
            _createVNode(_component_Button, {
              label: _ctx.i18n.$gettext('Speichern'),
              icon: "pi pi-check",
              autofocus: "",
              disabled: !_ctx.canAddMembers,
              onClick: _ctx.addNewTemMembers
            }, null, 8, ["label", "disabled", "onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _createVNode(_component_UserPicker, {
                  modelValue: _ctx.newTeamMembers,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.newTeamMembers) = $event)),
                  label: _ctx.i18n.$gettext('Sachbearbeiter'),
                  users: _ctx.filteredEditorsOptions
                }, null, 8, ["modelValue", "label", "users"])
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTeamMembers, (user, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user.email,
                    class: "card d-flex flex-row flex-wrap align-items-center p-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("p", _hoisted_111, [
                        _createElementVNode("span", _hoisted_112, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Name")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(": ")
                        ]),
                        _createTextVNode(_toDisplayString(_ctx.displayUser(user)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_113, [
                        _createElementVNode("span", _hoisted_114, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("E-Mail")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(": ")
                        ]),
                        _createTextVNode(_toDisplayString(user.email), 1)
                      ])
                    ]),
                    _createVNode(_component_Button, {
                      class: "p-button-danger flat p-button-text",
                      icon: "pi pi-trash",
                      onClick: ($event: any) => (_ctx.newTeamMembers.splice(i, 1))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTeamMembers, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: role.userName,
                    class: "card d-flex flex-row flex-wrap align-items-center p-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("p", _hoisted_118, [
                        _createElementVNode("span", _hoisted_119, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Name")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(": ")
                        ]),
                        _createTextVNode(_toDisplayString(_ctx.displayName(role.userName)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_120, [
                        _createElementVNode("span", _hoisted_121, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("E-Mail")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(": ")
                        ]),
                        _createTextVNode(_toDisplayString(role.userName), 1)
                      ])
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.displayRole(role.role)), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "onHide"])
      ]))
}